import React, { useRef } from 'react';
import { Alert, Box, Button, Paper, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import { usePublicZone } from '../zones/zones.hook';
import { ZoneServiceLogForm } from '../../forms/zones/zone-service-log/zone-service-log.form';
import { DialogActions, DialogContent } from '../../components';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import { Dialog } from '../../components/zone-landing-page';
import { ROUTES } from '../../consts';
import { IZone } from '../../models';

export const EmployeePage = () => {
  const { code } = useParams<{ code: string }>();
  const [confirmationDialog, setConfirmationDialog] = React.useState(false);
  const form = useRef<any>();
  const navigate = useNavigate();

  let selectedZone: IZone | null = null;
  if (code) {
    const result = usePublicZone({ code });
    // eslint-disable-next-line prefer-destructuring
    selectedZone = result[1];
  }

  const submitForm = () => {
    form.current.onSubmit();
  };

  const handleSuccess = () => {
    setConfirmationDialog(true);
  };

  const handleClose = () => {
    setConfirmationDialog(false);
    if (selectedZone) {
      navigate(`/code/${ROUTES.CODE_PAGE.replace(':code', selectedZone.code)}`);
    }
  };

  return (
    <Box>
      <Box sx={{ textAlign: 'center', my: 4 }}>
        <Typography>{dayjs().format('dddd D MMMM YYYY')}</Typography>
        <Typography>{dayjs().format('h : mm A')}</Typography>
      </Box>
      <Box sx={{ p: 2 }}>
        <Typography sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center' }}>
          Select all the services you performed
        </Typography>
        {selectedZone && (
          <Box>
            <Box sx={{ mb: '175px' }}>
              <ZoneServiceLogForm ref={form} zone={selectedZone} next={handleSuccess} />
            </Box>

            <Paper
              sx={{ position: 'fixed', bottom: 100, width: '100%', margin: '0 -16px', p: 2, maxWidth: 600 }}
              elevation={0}
            >
              <Button variant="contained" sx={{ mb: 1 }} onClick={submitForm}>
                Register Service
              </Button>
            </Paper>

            <ConfirmationDialog open={confirmationDialog} onClose={handleClose} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

const ConfirmationDialog = (props: { open: boolean; onClose: () => void }) => {
  const { open, onClose } = props;
  const theme = useTheme();

  return (
    <Dialog open={open}>
      <DialogContent>
        <Alert
          variant="filled"
          icon={<CheckCircleIcon />}
          style={{ backgroundColor: theme.palette.primary.main, borderRadius: 50 }}
        >
          Service has been saved
        </Alert>
        <Box sx={{ textAlign: 'center', my: 4 }}>
          <Typography>{dayjs().format('dddd D MMMM YYYY')}</Typography>
          <Typography>{dayjs().format('h : mm A')}</Typography>
        </Box>

        <Typography variant="subtitle2" color="primary" sx={{ textAlign: 'center' }}>
          Thank you for your hard work!
        </Typography>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Button startIcon={<CloseIcon />} onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
